Date.prototype.toDateInputValue = (function () {
    let local = new Date(this);
    local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
});

export function getAge(dateOfBirth, format) {
    const dob = new Date(dateOfBirth);
    //extract the year, month, and date from user date input  
    let dobYear = dob.getYear();
    let dobMonth = dob.getMonth();
    let dobDate = dob.getDate();
    //get the current date from the system  
    let now = new Date();
    //extract the year, month, and date from current date  
    let currentYear = now.getYear();
    let currentMonth = now.getMonth();
    let currentDate = now.getDate();
    //declare a variable to collect the age in year, month, and days  
    let age = {};
    let ageString = "";
    let monthAge = "";
    let dateAge = "";

    //get years  
    let yearAge = currentYear - dobYear;
    //get months  
    if (currentMonth >= dobMonth)
        //get months when current month is greater  
        monthAge = currentMonth - dobMonth;
    else {
        yearAge--;
        monthAge = 12 + currentMonth - dobMonth;
    }
    //get days  
    if (currentDate >= dobDate)
        //get days when the current date is greater  
        dateAge = currentDate - dobDate;
    else {
        monthAge--;
        dateAge = 31 + currentDate - dobDate;
        if (monthAge < 0) {
            monthAge = 11;
            yearAge--;
        }
    }

    if (format && format == 'month') return monthAge + yearAge * 12;
    if (format && format == 'days')  return dateAge + monthAge * 30 + yearAge * 365;
    if (format && format == 'years') return yearAge;

    //group the age in a single variable  
    age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
    };

    if ((age.years > 0) && (age.months > 0) && (age.days > 0))
        ageString = age.years + "a, " + age.months + "m";// et " + age.days + " jours";
    else if ((age.years == 0) && (age.months == 0) && (age.days > 0))
        ageString = age.days + "j";
    //when current month and date is same as birth date and month  
    else if ((age.years > 0) && (age.months == 0) && (age.days == 0))
        ageString = age.years + "a ";
    else if ((age.years > 0) && (age.months > 0) && (age.days == 0))
        ageString = age.years + "a, " + age.months + "m";
    else if ((age.years == 0) && (age.months > 0) && (age.days > 0))
        ageString = age.months + "m, " + age.days + "j";
    else if ((age.years > 0) && (age.months == 0) && (age.days > 0))
        ageString = age.years + "a, " + age.days + "j";
    else if ((age.years == 0) && (age.months > 0) && (age.days == 0))
        ageString = age.months + "m";
    //when current date is same as dob(date of birth)  
    else ageString = "1 j";

    return ageString;
}

export function getRemainingDays(actionDate, actionDays) {
    let _date = new Date(actionDate);
    _date.setDate(_date.getDate() + actionDays); 
    const days = Math.ceil((Date.parse(_date) - Date.parse(new Date())) / 86400000);
    return !days ? 0 : days;
}

export function nl2br(str) {
    if (str) {
        return str.split("\n").map((item, key) => {
          return (
            <span key={key}>
              {item}
              <br />
            </span>
          );
        });
      }
}

export default Date;